"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createI18nConfig_exports = {};
__export(createI18nConfig_exports, {
  default: () => createI18nConfig
});
module.exports = __toCommonJS(createI18nConfig_exports);
var import_node_process = __toESM(require("node:process"), 1);
var import_constants = require("../constants");
let DEFAULT_LOCALE = "en";
function isLocaleFourDigit(locale) {
  return locale.split("_").length === 2 || locale.split("-").length === 2;
}
function getCorrectCode(locale) {
  if (!isLocaleFourDigit(locale))
    return locale;
  return locale.split("_").length === 2 ? locale.split("_")[0] : locale.split("-")[0];
}
function getCorrectIso(locale) {
  if (!isLocaleFourDigit(locale))
    return import_constants.ISO_MAP[locale] ?? DEFAULT_LOCALE;
  if (locale === import_constants.ACCURATE_EN_FOUR_DIGIT_ISO)
    return "en";
  return locale;
}
function getLocales() {
  const { env } = import_node_process.default;
  const locales = env?.LOCALES;
  return !locales ? [{
    code: DEFAULT_LOCALE,
    name: DEFAULT_LOCALE,
    file: "getTranslations.js",
    iso: import_constants.ISO_MAP[DEFAULT_LOCALE] ?? DEFAULT_LOCALE
  }] : locales.split(",").reduce((languages, locale) => {
    return [
      ...languages,
      {
        code: getCorrectCode(locale),
        name: getCorrectCode(locale),
        file: "getTranslations.js",
        iso: getCorrectIso(locale)
      }
    ];
  }, []);
}
function createI18nConfig() {
  const { env } = import_node_process.default;
  if (env?.DEFAULT_LOCALE)
    DEFAULT_LOCALE = env?.DEFAULT_LOCALE;
  return {
    lazy: true,
    langDir: "lang/",
    defaultLocale: DEFAULT_LOCALE,
    locales: getLocales(),
    vueI18nLoader: true
  };
}
;
